import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getAppraisalReports, IInspectifyReport } from 'services'
import { Modal, PlainTable } from 'stories/components'
import { toTitleCaseFromSnake } from 'utils'

export const Inspectify = ({ data, onClose }: { data: Record<string, any>; onClose: Function }) => {
  const [reports, setReports] = useState<IInspectifyReport[]>([])
  const [loading, setLoading] = useState(false)

  const { orderID } = data.thirdPartyAPI || {}

  const getReports = async () => {
    setLoading(true)
    const res = await getAppraisalReports('inspectify' as any, orderID)
    setLoading(false)
    if (res.success) {
      setReports(res.data)
    }
  }

  useEffect(() => {
    getReports()
  }, [])

  const renderReportsTable = () => {
    if (reports.length === 0 && !loading) {
      return <div className="text-center py-4 text-gray-500">No reports found</div>
    }

    const tableData = reports.map((report, index) => [
      index + 1,
      <div className="py-1">
        {report.inspection_types.map((type, idx) => (
          <div key={idx} className="text-sm">
            {toTitleCaseFromSnake(type)}
          </div>
        ))}
      </div>,
      <div className="py-1">{report.template_report_names.join(', ')}</div>,
      <a
        href={report.file_url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-shade-blue hover:underline cursor-pointer inline-flex items-center gap-1"
      >
        <ArrowTopRightOnSquareIcon className="w-4 h-4" />
      </a>,
    ])

    return (
      <div className="mt-4">
        <PlainTable
          header={['No', 'Inspection Type', 'Templates', 'Open File']}
          tdClass={'px-4 py-2'}
          data={tableData}
        />
      </div>
    )
  }

  return (
    <Modal isOpen title={`Inspectify - ${orderID}`} titleOkay="" onClose={() => onClose(false)}>
      <div className="text-gray-600 text-md overflow-hidden min-w-[750px] max-w-2xl relative">
        <LayoutLoading show={loading} />
        <div className="py-4">{renderReportsTable()}</div>
      </div>
    </Modal>
  )
}
